<template>
  <div class="panel margin--bottom">
    <bar-card :bg="'border4'">
      <v-title>项目建设</v-title>
      <div class="content">
        <div class="img-box flex">
          <div class="ltarget flex-between">
            <div
              class="target"
              v-for="(item, index) in baseList"
              :key="index"
              :style="{ bottom: item.top }"
            >
              <div :class="'navName' + index" class="navValue">
                <span class="num">{{ item.value }}</span
                >（{{ item.unit }}）
              </div>
              <div :class="'navName' + index" class="navTitle">
                {{ item.name }}
              </div>
              <img :src="item.img" />
            </div>
          </div>
        </div>
        <div class="bgImg flex">
          <img
            class="himg aimg"
            style="width: 88%; margin: auto"
            src="~images/index/xmjs/808fe4e2b8a803ac20b92ec43cfc7922.png"
          />
          <img
            class="simg aimg"
            style="width: 88%; margin: auto"
            src="~images/index/xmjs/808fe4e2b8a803ac20b92ec43cfc792.png"
          />
        </div>
        <div class="progess">
          <div
            class="progessRow flex"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="name">{{ item.name }}</div>
            <div class="jdt flex" :class="'ys' + index">
              <el-progress
                :percentage="item.value"
                :stroke-width="10"
              ></el-progress>
            </div>
          </div>
        </div>
      </div>
    </bar-card>
  </div>
</template>

<script>
// import { getScreenV2XmGetWorl } from "@/api/home";
import { getScreenV2XmGetWorl, getScreenV2XMTJ } from "@/api/home";
export default {
  data() {
    return {
      list: [],
      baseList: [
        {
          img: require("images/index/xmjs/ggqy.png"),
          name: "",
          value: "",
          unit: "项",
          top: "-3%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/tdlz.png"),
          top: "-13%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/kjyxx.png"),
          top: "-1%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/cynh.png"),
          top: "-16%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/nyss.png"),
          top: "-2%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/dktx.png"),
          top: "-17%"
        },
        {
          name: "",
          value: "",
          unit: "项",
          img: require("images/index/xmjs/qt.png"),
          top: "-7%"
        }
      ]
    };
  },
  mounted() {
    const simg = document.getElementsByClassName("simg")[0];
    const himg = document.getElementsByClassName("himg")[0];
    const progess = document.getElementsByClassName("progess")[0];
    const ltarget = document.getElementsByClassName("ltarget")[0];
    progess.style.transition = ".3s";
    ltarget.style.transition = ".3s";
    progess.style.opacity = "0";
    progess.style.transform = "translate(0,-5px)";
    ltarget.style.opacity = "0";
    ltarget.style.transform = "translate(0,-5px)";
    setTimeout(() => {
      simg.style.display = "none";
      himg.style.display = "block";
      progess.style.opacity = "1";
      progess.style.transform = "translate(0,0)";
      ltarget.style.opacity = "1";
      ltarget.style.transform = "translate(0,0)";
      this.dataLoad();
    }, 1600);
  },
  methods: {
    dataLoad() {
      getScreenV2XmGetWorl().then(res => {
        this.list = res.data.map(e => {
          e.value = Number(e.value);
          return e;
        });
      });
      //   this.list = [
      //     { name: "开工率", value: "84.21" },
      //     { name: "完工率", value: "5.26" },
      //     { name: "总进度", value: "69.47" }
      //   ];
      //   let data = [
      //     { id: "8a", name: "其它", count: "1" },
      //     { id: "6a", name: "贷款贴息", count: "0" },
      //     { id: "4a", name: "公共区域品牌", count: "0" },
      //     { id: "5a", name: "科技与信息支撑", count: "3" },
      //     { id: "7a", name: "土地流转", count: "0" },
      //     { id: "2a", name: "农业设施", count: "4" },
      //     { id: "3a", name: "产业融合", count: "11" }
      //   ];
      //   this.baseList[0].name = data[0].name;
      //   this.baseList[0].value = data[0].count;
      //   this.baseList[1].name = data[3].name;
      //   this.baseList[1].value = data[3].count;
      //   this.baseList[2].name = data[5].name;
      //   this.baseList[2].value = data[5].count;
      //   this.baseList[3].name = data[4].name;
      //   this.baseList[3].value = data[4].count;
      //   this.baseList[4].name = data[6].name;
      //   this.baseList[4].value = data[6].count;
      //   this.baseList[5].name = data[1].name;
      //   this.baseList[5].value = data[1].count;
      //   this.baseList[6].name = data[2].name;
      //   this.baseList[6].value = data[2].count;
      getScreenV2XMTJ().then(res => {
        let data = res.data;
        this.baseList[0].name = data[0].name;
        this.baseList[0].value = data[0].count;
        this.baseList[1].name = data[3].name;
        this.baseList[1].value = data[3].count;
        this.baseList[2].name = data[5].name;
        this.baseList[2].value = data[5].count;
        this.baseList[3].name = data[4].name;
        this.baseList[3].value = data[4].count;
        this.baseList[4].name = data[6].name;
        this.baseList[4].value = data[6].count;
        this.baseList[5].name = data[1].name;
        this.baseList[5].value = data[1].count;
        this.baseList[6].name = data[2].name;
        this.baseList[6].value = data[2].count;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  height calc(42% - 8px)
  font-size .06rem

.content
  height calc(100% - .2rem)
  position relative

.flex
  display flex
  justify-content center
.num
  font-size 0.12rem
.img-box
  height 65%
  width 100%
  position relative
  justify-content center

.bgImg
  width 100%
  position absolute
  height 100%
  top 0
  left 0

.ltarget
  position relative
  height 100%
  z-index 9
  width 80%

.target
  position relative
  color #fff
  text-align center
  font-size .065rem

.circle
  position relative
  display inline-block

  img
    vertical-align middle

.progess
  height calc(30% - 0.05rem)
  margin-bottom 0.05rem
  display flex
  justify-content center
  align-items center
  flex-wrap wrap
  box-sizing border-box
  padding 0 0.05rem

.navName0
  width .3rem
  transform translate(-23%, -130%)
.navName1
  width .3rem
  transform translate(-10%, -100%)
.navName2
  width .5rem
  transform translate(-18%, -120%)
.navName3
  width .5rem
  transform translate(-20%, -100%)
.navName4
  width .3rem
  transform translate(24%, -120%)
.navName5
  width .5rem
  transform translate(-30%, -100%)
.navName6
  width .3rem
  transform translate(-20%, -120%)
.navTitle
  position absolute
  text-align center
  width max-content
.navValue
  position absolute
  color #0ff
  top -0.08rem
  text-align center
.progessRow
  padding 0px
  width 100%

  >>>.el-progress-bar
    padding-right 70px

  >>>.el-progress__text
    margin-left 0
    color #fff

  >>>.el-progress-bar__outer
    border-radius 0
    // background-image linear-gradient(#d9b200 1%, #ffdd40) !important

  >>>.el-progress-bar__inner
    border-radius 0
.jdt
  justify-content center
  width 85%
  >>>.el-progress
    width 100%
  >>>.el-progress-bar__outer
    height 10px !important
  >>>.el-progress-bar
    width 96% !important
  >>>.el-progress__text
    color #fff
  >>>.el-progress-bar__outer
    background-color rgba(11,46,87,0.8) !important
.ys0
  color #fff !important
  >>>.el-progress-bar__inner
    background-image linear-gradient(to right, #072a5e, #1090DC) !important
  >>>.el-progress__text
    color #fff !important
.ys1
  color #fff !important
  >>>.el-progress-bar__inner
    background-image linear-gradient(to right, #072a5e, #7338EA) !important
  >>>.el-progress__text
    color #fff !important
.ys2
  color #fff !important
  >>>.el-progress-bar__inner
    background-image linear-gradient(to right, #072a5e, #17C4B0) !important
  >>>.el-progress__text
    color #fff !important
.name
  margin-right 0.06rem

.aimg
  position absolute
  top 45%
  left 50%
  transform translate(-50%,-50%)

.himg
  display none
.simg
  top 45%
  height 100%
</style>
